import axios from 'axios';
import { toast } from 'react-toastify';
import {
  EVENTS_UPDATE_EVENT_BEGIN,
  EVENTS_UPDATE_EVENT_SUCCESS,
  EVENTS_UPDATE_EVENT_FAILURE,
  EVENTS_UPDATE_EVENT_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function updateEvent(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: EVENTS_UPDATE_EVENT_BEGIN,
    });
    const { projectId, version, eventId } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/events/${eventId}`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: EVENTS_UPDATE_EVENT_SUCCESS,
              data: res.data,
            });
            toast.success('Updated Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: EVENTS_UPDATE_EVENT_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: EVENTS_UPDATE_EVENT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateEventError() {
  return {
    type: EVENTS_UPDATE_EVENT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_UPDATE_EVENT_BEGIN:
      return {
        ...state,
        updateEventPending: true,
        updateEventError: null,
      };

    case EVENTS_UPDATE_EVENT_SUCCESS:
      let events = state.events;
      let index = events.findIndex(function (event, i) {
        return event._id === action.data._id;
      });
      events[index] = action.data;
      return {
        ...state,
        updateEventPending: false,
        updateEventError: null,
        events: events,
        selectedEvent: action.data,
      };

    case EVENTS_UPDATE_EVENT_FAILURE:
      return {
        ...state,
        updateEventPending: false,
        updateEventError: action.data.error,
      };

    case EVENTS_UPDATE_EVENT_DISMISS_ERROR:
      return {
        ...state,
        updateEventError: null,
      };

    default:
      return state;
  }
}
